import { Link } from 'react-router-dom';
import { ReleaseMeta } from './ReleaseMeta';

export function Footer(): JSX.Element {
  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-950">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 py-4 sm:flex-row sm:justify-between sm:px-6 lg:px-8">
        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-medium text-gray-600 dark:text-gray-300"
        >
          <Link to="/about" className="hover:text-blue-700 dark:hover:text-blue-300">
            About
          </Link>
          <Link to="/privacy" className="hover:text-blue-700 dark:hover:text-blue-300">
            Privacy
          </Link>
          <Link to="/cookies" className="hover:text-blue-700 dark:hover:text-blue-300">
            Cookies
          </Link>
        </nav>
        <ReleaseMeta />
      </div>
    </footer>
  );
}
